import { SET_AGUARDAR } from "../actions";


export default function aguardarReducer(state = null, action){

    switch(action.type){
        case SET_AGUARDAR:
            return action.value
        default:
            return state;
    }
}